import React, { useState } from "react";

import { Plan } from '@/types';

import AppInput from "@/components/AppInput";
import AppButton from "@/components/AppButton";
import AppSwitch from "@/components/AppSwitch";
import AppBox from "@/components/AppBox";

interface CreatePlanModalProps {
  onSubmit: (form: Plan) => void;
  currentPlan: Partial<Plan>;
}

const CreatePlanModal: React.FC<CreatePlanModalProps> = ({
  onSubmit,
  currentPlan,
}) => {
  // const [form, setForm] = useState<Plan>(
  //   currentPlan.api_id
  //     ? (currentPlan as Plan)
  //     : { api_id: "", name: "", trial: "", current: false }
  // );

  const [form, setForm] = useState<Plan>({
    id: currentPlan.id ?? 0,
    api_id: currentPlan.api_id ?? "",
    name: currentPlan.name ?? "",
    trial: currentPlan.trial ?? "",
    current: currentPlan.current ?? false,
    price: currentPlan.price ?? 0,
  });

  const [errors, setErrors] = useState<Partial<Plan>>({
    api_id: "",
    name: "",
    trial: "",
    current: false,
  });

  // Handle input change
  const handleChange =
    (field: keyof Plan) =>
    (value: string | boolean) => {
      if (errors[field]) {
        setErrors((state) => ({
          ...state,
          [field]: "",
        }));
      }
      setForm((state) => ({
        ...state,
        [field]: value,
      }));
    };

  // Handle form submission
  const handleSubmit = () => {
    let error = false;

    // Validate required fields
    Object.keys(form).forEach((field) => {
      if (!form[field as keyof Plan] && field !== "current") {
        setErrors((state) => ({
          ...state,
          [field]: `${field.charAt(0).toUpperCase() + field.slice(1)} is required`,
        }));
        error = true;
      }
    });

    if (!error) {
      onSubmit(form);
    }
  };

  return (
    <AppBox column gap={4} className="w-full">
      {/* API ID */}
      <AppInput
        type="text"
        label="API ID"
        fullWidth
        value={form.api_id}
        onChange={(e) => handleChange("api_id")(e.target.value)}
        error={errors.api_id}
        onPressEnter={handleSubmit}
      />

      {/* Plan Name */}
      <AppInput
        type="text"
        label="Plan Name"
        fullWidth
        value={form.name}
        onChange={(e) => handleChange("name")(e.target.value)}
        error={errors.name}
        onPressEnter={handleSubmit}
      />

      {/* Plan Trial */}
      <AppInput
        type="number"
        label="Plan Trial"
        fullWidth
        value={form.trial}
        onChange={(e) => handleChange("trial")(e.target.value)}
        error={errors.trial}
        onPressEnter={handleSubmit}
      />

      {/* Default Plan Switch */}
      <AppSwitch
        label="Default plan"
        checked={form.current}
        onChange={(checked) => handleChange("current")(checked)}
      />

      {/* Submit Button */}
      <AppBox className="flex justify-end">
        <AppButton onClick={handleSubmit}>
          {currentPlan.api_id ? "Update Plan" : "Create new plan"}
        </AppButton>
      </AppBox>
    </AppBox>
  );
};

export default CreatePlanModal;